import {ClassName} from '#/utils/utils';
import {KeyPrefix, ParseKeysByKeyPrefix} from 'i18next';
import {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';

type HomeHowItWorksItemProps = {
  i18nKey: ParseKeysByKeyPrefix<KeyPrefix<'translation'>, 'pages.landing.howItWorks'>;
  textColor?: string;
} & ClassName;

export const HomeHowItWorksItem: FunctionComponent<HomeHowItWorksItemProps> = ({i18nKey, className}) => {
  const {t} = useTranslation('translation', {keyPrefix: `pages.landing.howItWorks.${i18nKey}`});

  return (
    <div className={`flex items-center gap-6 break-keep overflow-hidden ${className}`}>
      <div className='bg-deepblue w-10 h-10 overflow-hidden flex justify-center items-center rounded-full text-white font-bold'>
        {t('index')}
      </div>
      <div>
        <h3 className={'text-lg font-bold'}>{t('title')}</h3>
        <span>{t('description')}</span>
      </div>
    </div>
  );
};
